export enum ManualReviewActionType {
  REFRESH_PENDING_STATUSES = "update_override",
  UPDATE_OVERRIDE = "update_override",
  UPDATE_ACTIVE_ASSAY = "update_active_assay",
  UPDATE_KIT_UNDER_REVIEW = "update_kit_under_review",
  RESET_ASSAY = "reset_assay",
}
